<template>
  <div class="VacationArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('extraWorkDetails')">
        <v-row class="pa-2">
          <v-col cols="6"
            >{{ $t("PageNo") }}:<span class="text-value">{{
              details.pageno
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("RequestedPersonName") }}:<span class="text-value">{{
              details.personName
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("requestType") }}:<span class="text-value">{{
              item.isGroup ? $t("groupRequest") : $t("oneRequest")
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("LastChangeDate") }}:<span class="text-value">{{
              details.lastChangeDate
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("status") }}:<span
              class="text-value"
              v-text="
                item.statusType +
                '-' +
                (details.IsTransfer ? 'انتقال داده شده' : 'انتقال داده نشده')
              "
            ></span
          ></v-col>
          <v-col cols="6"
            >{{ $t("ApprovedPerson") }}:<span
              class="text-value"
              v-text="ApprovedPerson"
            ></span
          ></v-col>
          <v-col cols="12">
            {{ $t("description") }}:

            <span class="text-value">
              {{ details.personName }}:{{ details.userDescription }} <br />
              <span
                >تائید / رد کننده: {{ details.adminDescription }}</span
              ></span
            ></v-col
          >
          <v-col v-if="details.personelsName" cols="12">
            {{ $t("personelsName") }}:

            <span class="text-value"> {{ details.personelsName }} <br /> </span>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small v-if="visibleEdit" @click="edit">{{ $t("edit") }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="deleteItem">{{
            $t("delete")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          v-if="ShowExtraWorkFlow"
          :pageNo="details.pageno ? details.pageno.toString() : ''"
          :pageType="4"
          :year="item.YEAR"
        />
        <div v-else class="text-center py-3">
          <span> روند جریان برگه های منتقل شده قابل مشاهده نمی باشد </span>
        </div>
      </box>
    </v-dialog>
  </div>
</template>

<script>
import ArchiveDetalsFlow from "./ArchiveDetalsFlow.vue";
import ResultType from "../../model/ResultType";
import RequestState from "../../model/RequestState";

export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return {
      visible: false,
      item: "",
      details: "",
      visibleEdit: false,
      visibleDelete: false,
      ApprovedPerson: "",
      ShowExtraWorkFlow: true,
    };
  },
  methods: {
    show(item, details) {
      this.visible = true;
      this.item = item;
      this.details = details;
      this.checkActionsVisiblity();
      this.getApprovedPerson();
    },
    hide() {
      this.visible = false;
    },
    getApprovedPerson() {
      if (this.details.approvedBy.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.approvedBy.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.approvedBy.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
      if(this.details.IsTransferransfer != true && this.details.DB == 1){
        // this.externalFlow=false;
        this.ShowExtraWorkFlow=true;
      }
      else{
        // this.externalFlow=true;
        this.ShowExtraWorkFlow=false;

      }
    },
    checkActionsVisiblity() {
      ////console.log(String.fromCharCode(1740));
      ////console.log(String.fromCharCode(1610));
      this.visibleEdit = false;
      this.visibleDelete = false;

      switch (this.item.status) {
        case 0: //darkhost avaliyeh
        case 1: //bargasht khordeh
        case 2: //ersal mojadad
        case 4: //rad shodeh
          //btnPrint.Visible = false;
          this.visibleEdit = true;

          if (this.item.status == 1) {
            this.visibleEdit = false;
            //emkan hazfe darkhoste rad shodeh
            this.visibleDelete =
              this.$store.state.personel.personelDetail.Permission[15].toString() ==
              "1";
          } else {
            this.visibleDelete = true;
          }
      }
    },
    edit() {
      this.visible = false;
      //console.log(this.details);
      //console.log(this.item);
      
      let details = {
        PageNo: this.item.pageNO,
        Year: this.item.YEAR,
        DBKind: this.item.DBKIND,
        selectedPerno:this.item.perno,
        from:'request-extra-work-archive'
      };
      //this.details["Year"] = this.item.YEAR;
      if (this.item.isGroup == 1) {
        this.$router.push({
          name: "extrawork-group-request",
          params: { details: details },
        });
      } else {
        this.$router.push({
          name: "request-extra-work",
          params: { details: details },
        });
      }
    },
    deleteItem() {
      var params = [
        {
          PageNo: this.item.pageNO,
          Year: this.item.YEAR,
          //AdminPerno: this.item.perno.trim(),
          RequestState: RequestState.RequestState.Delete,
          ReasonOfAdmin: "",
          Status: "-1",
        },
      ];

      this.$store
        .dispatch("OprationOnExtraWorkRequest", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.$emit("refresh");

            if (result.data?.length > 0) {
              if (result.data[0].Status == "-1") {
                this.$refs.snackbar.show("error", result.data[0].Description);
              } else {
                var description = result.data[0].Description;
                this.$refs.snackbar.show("success", description);
              }
            }
          } else {
            this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style>
</style>